export default "__VITE_ASSET__CzryIfxQ__"